import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import useMobileLayout from 'Hooks/useMobileLayout';
import TimerIcon from '@material-ui/icons/Timer';
import WelcomeParagraphs from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/WelcomeParagraphs';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import Slide from '@mui/material/Slide';
import { getBorderRadius } from 'Components/utils';
import useIsDigitalOnboarding from 'Hooks/useIsDigitalOnboarding';
import { FDBodyText, FDBox } from '@facet-wealth/design';
import WelcomeBlurb from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/WelcomeBlurb';
import WelcomeLowerContentWrapper
  from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/WelcomeLowerContent/WelcomeLowerContentWrapper';
import onboardingStyles from '../../../../../../Onboarding/Pages/Survey/SurveyStep/StepLibrary/Welcome/styles';

const styles = (theme) => ({
  ...onboardingStyles(theme),
  root: {},
  rootDesktop: {},
  lowerContent: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    padding: theme.spacing(2),
    top: 0,
  },
  lowerContentDesktop: {
    position: 'relative',
    padding: theme.spacing(2, 3),
    top: 0,
  },
  imageCardContainer: {
    ...onboardingStyles(theme).imageCardContainer,
    position: 'relative',
    top: -55, // Header size
    marginBottom: -55,
  },
  imageCardContainerDesktop: {
    ...onboardingStyles(theme).imageCardContainerDesktop,
    position: 'relative',
    top: -55, // Header size
    marginBottom: -55,
  },
  digitalOnboardingImageCardContainer: {
    top: -80,
    height: 420,
  },
  digitalOnboardingImageCardContainerMobile: {
    width: '109%',
    left: '-4.5%',
  },
  container: {
    padding: 0,
  },
  gradient: {
    ...getBorderRadius(theme.radius.md, {
      bottomLeft: true,
      bottomRight: true,
    }),
    width: '100%',
    height: '100%',
    padding: theme.spacing(2),
    background: 'linear-gradient(0deg, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.1) 20%, rgba(0,0,0,0) 50%, rgba(0,0,0,0.1) 80%, rgba(0,0,0,0.5) 100%)',
  },
  welcomeParagraph: {
    ...onboardingStyles(theme),
    whiteSpace: 'pre-line',
  },
});

const Layout = ({
  className,
  classes,
}) => {
  const {
    resource,
  } = useMetaLayoutContext();

  const isMobile = useMobileLayout();
  const isDigitalOnboarding = useIsDigitalOnboarding();
  const title = resource.attr('title');

  return (
    <div
      className={classNames({
        [classes.root]: isMobile,
        [classes.rootDesktop]: !isMobile,
      }, className)}
    >
      <Slide
        direction={'down'}
        in
      >
        <div
          className={classNames(classes.imageCardContainer, {
            [classes.imageCardContainerDesktop]: !isMobile,
            [classes.digitalOnboardingImageCardContainer]: isDigitalOnboarding,
            [classes.digitalOnboardingImageCardContainerMobile]: isDigitalOnboarding && isMobile,
          }, classes.container)}
          style={{ backgroundImage: `url('${resource.attr('imageUrl')}')` }}
        >
          <div className={classes.gradient}>
            <div className={classes.imageCardContent}>
              <div className={classes.imageCardHeader}>
                <Typography
                  className={classes.titleText}
                  color={'white'}
                  variant={'h2'}
                  weight={'medium'}
                  test={'wizard-step-title'}
                >
                  {title}
                </Typography>

                {resource.attr('estimatedTime') && (
                  <Typography
                    className={classes.durationText}
                    color={'white'}
                    variant={'h4'}
                    weight={'medium'}
                  >
                    <TimerIcon className={classes.durationIcon} />
                    {resource.attr('estimatedTime')}
                  </Typography>
                )}
              </div>
            </div>
          </div>
        </div>
      </Slide>
      <WelcomeLowerContentWrapper className={classNames(classes.lowerContent, { [classes.lowerContentDesktop]: !isMobile })}>
        {resource.attr('subtitle') && (
          <WelcomeParagraphs
            className={classes.welcomeParagraph}
            paragraphs={resource.attr('subtitle').map(text => ({ text }))}
          />
        )}
        {resource.attr('additionalDetailItems') && (
          <WelcomeBlurb
            title={resource.attr('additionalDetailTitle')}
            bullets={resource.attr('additionalDetailItems').map((text) => ({ text }))}
          />
        )}
        {resource.attr('disclaimer') && (
          <FDBox paddingY={4}>
            <FDBodyText value={resource.attr('disclaimer')} size={'sm'} color={'textDisabled'} />
          </FDBox>
        )}
      </WelcomeLowerContentWrapper>
    </div>
  );
};

Layout.defaultProps = {
  className: '',
};

Layout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Layout);
